import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import { UserService } from "../../services/user.service";
import { User } from "../../interfaces/user.interface";
import { City } from "../../interfaces/city.interface";
import { State } from "../../interfaces/state.interface";
import { ToastrService } from 'ngx-toastr';
import { MatFormField, MatLabel, MatFormFieldModule } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatOption, MatSelect } from "@angular/material/select";
import { MatCheckbox } from "@angular/material/checkbox";
import { DatePipe } from "@angular/common";
import { CommonModule } from "@angular/common";
import { MatRadioModule} from "@angular/material/radio";
import { MatButton } from "@angular/material/button";
import { PhoneMaskDirective } from "../../_directives/phone-mask.directive";
import { CepMaskDirective } from "../../_directives/cep-mask.directive";
import { MatIcon } from "@angular/material/icon";

interface Nationality {
  value: string;
  viewValue: string;
}

interface MaritalStatus {
  value: string;
  viewValue: string;
}

interface Degree {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-user',
  standalone: true,
  imports: [MatFormFieldModule, MatCardModule, ReactiveFormsModule, MatLabel, MatInput, MatFormField, MatSelect, MatOption, MatCheckbox, DatePipe, CommonModule, MatRadioModule, MatButton, PhoneMaskDirective, CepMaskDirective, MatIcon],
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
})
export class UserComponent implements OnInit {
  user: User | null = null;
  isLoading = true;
  userForm: FormGroup;
  mostrarcivilName = false;
  hasSocialName: string = '0';
  nationality: Nationality[] = [];
  maritalStatus: MaritalStatus[] = [];
  statesApi: State[]  = [];
  cityBirthApi: City[] = [];
  cityApi: City[] = [];
  cityGraduationApi: City[] = [];
  degree: Degree[] = [];

  constructor(private userService: UserService, private toastService: ToastrService, private fb: FormBuilder) {
    this.userForm = this.fb.group({
      name: new FormControl('', [Validators.required, Validators.minLength(6)]),
      email: new FormControl('', [Validators.required, Validators.email]),
      hasSocialName: new FormControl('0'),
      civilName: new FormControl(''),
      username: new FormControl({ value: '', disabled: true }),
      phone: new FormControl('', [Validators.required, Validators.pattern(/^\(\d{2}\)\s\d{4,5}-\d{4}$/)]),
      cellphone: new FormControl('', [Validators.pattern(/^\(\d{2}\)\s\d{4,5}-\d{4}$/)]),
      email2: new FormControl('', Validators.email),
      born: new FormControl('', Validators.required),
      nationality: new FormControl('', Validators.required),
      stateBirth: new FormControl(''),
      cityBirth: new FormControl(''),
      stateBirth2: new FormControl(''),
      cityBirth2: new FormControl(''),
      maritalStatus: new FormControl('', Validators.required),
      gender: new FormControl(''),
      gender2: new FormControl(''),
      passaport: new FormControl(''),
      rg: new FormControl(''),
      idDocument: new FormControl(''),
      rneDocument: new FormControl(''),
      rgOrganIssuer: new FormControl(''),
      rgStateIssuer: new FormControl(''),
      rgDateIssuer: new FormControl(''),
      voterRegistration: new FormControl(''),
      voterDate: new FormControl(''),
      voterZone: new FormControl(''),
      voterSection: new FormControl(''),
      militaryDocument: new FormControl(''),
      postalCode: new FormControl('', Validators.required),
      address: new FormControl('', Validators.required),
      addressNumber: new FormControl('', Validators.required),
      addressComplement: new FormControl(''),
      district: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      state: new FormControl(''),
      city: new FormControl(''),
      state2: new FormControl(''),
      city2: new FormControl(''),
      whereLive: new FormControl(''),
      profession: new FormControl(''),
      workplace: new FormControl(''),
      degree: new FormControl(''),
      graduationCourse: new FormControl(''),
      graduationCourseInstitution: new FormControl(''),
      graduationCourseCity: new FormControl(''),
      graduationCourseState: new FormControl(''),
      graduationCourseDate: new FormControl(''),
      censoAltasHabilidades: new FormControl(''),
      censoAltasHabilidadesTipo: new FormControl(''),
      censoCegueira:  new FormControl(''),
      censoDeficienciaAuditiva:  new FormControl(''),
      censoDeficienciaFisica:  new FormControl(''),
      censoDeficienciaFisicaDescricao:  new FormControl(''),
      censoDeficienciaIntelectual:  new FormControl(''),
      censoDeficienciaMultipla:  new FormControl(''),
      censoDescPrioridade1:  new FormControl(''),
      censoDescPrioridade2:  new FormControl(''),
      censoDescPrioridade3:  new FormControl(''),
      censoDescPrioridade4:  new FormControl(''),
      censoNaoInformar:  new FormControl(''),
      censoOutras:  new FormControl(''),
      censoOutrasDesc:  new FormControl(''),
      censoSurdez:  new FormControl(''),
      censoSurdocegueira:  new FormControl(''),
      censoTea:  new FormControl(''),
      censoTeaDescricao:  new FormControl(''),
      censoVisaoSubnormal:  new FormControl(''),
      acessibility: new FormControl('')
    });

    this.nationality = [
      { value: 'brasileira', viewValue: 'Brasileira' },
      { value: 'Brasileira (nascido no exterior)', viewValue: 'Brasileira (nascido no exterior)' },
      { value: 'afegÃ£', viewValue: 'afegÃ£' },
      { value: 'albanesa', viewValue: 'albanesa' },
      { value: 'alemÃ£', viewValue: 'alemÃ£' },
      { value: 'americana', viewValue: 'americana' },
      { value: 'angolana', viewValue: 'angolana' },
      { value: 'argelina', viewValue: 'argelina' },
      { value: 'australiana', viewValue: 'australiana' },
      { value: 'argentina', viewValue: 'argentina' },
      { value: 'austrÃ­aca', viewValue: 'austrÃ­aca' },
      { value: 'belga', viewValue: 'belga' },
      { value: 'boliviana', viewValue: 'boliviana' },
      { value: 'bÃºlgara', viewValue: 'bÃºlgara' },
      { value: 'cabo-verdense', viewValue: 'cabo-verdense' },
      { value: 'canadiana', viewValue: 'canadiana' },
      { value: 'chilena', viewValue: 'chilena' },
      { value: 'chinesa', viewValue: 'chinesa' },
      { value: 'cipriota', viewValue: 'cipriota' },
      { value: 'colombiana', viewValue: 'colombiana' },
      { value: 'croata', viewValue: 'croata' },
      { value: 'cubana', viewValue: 'cubana' },
      { value: 'dinamarquesa', viewValue: 'dinamarquesa' },
      { value: 'eslovaca', viewValue: 'eslovaca' },
      { value: 'eslovena', viewValue: 'eslovena' },
      { value: 'espanhola', viewValue: 'espanhola' },
      { value: 'finlandesa', viewValue: 'finlandesa' },
      { value: 'francesa', viewValue: 'francesa' },
      { value: 'grega', viewValue: 'grega' },
      { value: 'guineense', viewValue: 'guineense' },
      { value: 'holandesa', viewValue: 'holandesa' },
      { value: 'hÃºngara', viewValue: 'hÃºngara' },
      { value: 'indiana', viewValue: 'indiana' },
      { value: 'indonesa', viewValue: 'indonesa' },
      { value: 'inglesa', viewValue: 'inglesa' },
      { value: 'equatoriana', viewValue: 'equatoriana' },
      { value: 'iraniana', viewValue: 'iraniana' },
      { value: 'israelita', viewValue: 'israelita' },
      { value: 'italiana', viewValue: 'italiana' },
      { value: 'japonesa', viewValue: 'japonesa' },
      { value: 'jordana', viewValue: 'jordana' },
      { value: 'kosovar', viewValue: 'kosovar' },
      { value: 'libanesa', viewValue: 'libanesa' },
      { value: 'lÃ­bia', viewValue: 'lÃ­bia' },
      { value: 'lituana', viewValue: 'lituana' },
      { value: 'marroquina', viewValue: 'marroquina' },
      { value: 'mexicana', viewValue: 'mexicana' },
      { value: 'moÃ§ambicana', viewValue: 'moÃ§ambicana' },
      { value: 'neozelandesa', viewValue: 'neozelandesa' },
      { value: 'nigeriana', viewValue: 'nigeriana' },
      { value: 'norte-koreana', viewValue: 'norte-koreana' },
      { value: 'norueguesa', viewValue: 'norueguesa' },
      { value: 'paquistanesa', viewValue: 'paquistanesa' },
      { value: 'peruana', viewValue: 'peruana' },
      { value: 'polaca', viewValue: 'polaca' },
      { value: 'portuguesa', viewValue: 'portuguesa' },
      { value: 'queniana', viewValue: 'queniana' },
      { value: 'romena', viewValue: 'romena' },
      { value: 'ruandesa', viewValue: 'ruandesa' },
      { value: 'russa', viewValue: 'russa' },
      { value: 'santomense', viewValue: 'santomense' },
      { value: 'senegalesa', viewValue: 'senegalesa' },
      { value: 'sÃ­ria', viewValue: 'sÃ­ria' },
      { value: 'somalÃ­', viewValue: 'somalÃ­' },
      { value: 'sudanesa', viewValue: 'sudanesa' },
      { value: 'sueca', viewValue: 'sueca' },
      { value: 'sul-africana', viewValue: 'sul-africana' },
      { value: 'sul-koreana', viewValue: 'sul-koreana' },
      { value: 'tailandesa', viewValue: 'tailandesa' },
      { value: 'timorense', viewValue: 'timorense' },
      { value: 'tunisina', viewValue: 'tunisina' },
      { value: 'turca', viewValue: 'turca' },
      { value: 'ucraniana', viewValue: 'ucraniana' },
      { value: 'venezuelana', viewValue: 'venezuelana' },
      { value: 'vietinamita', viewValue: 'vietinamita' },
      { value: 'peruana', viewValue: 'peruana' }
    ];

    this.maritalStatus = [
      { value: 'solteiro', viewValue: 'Solteiro(a)' },
      { value: 'casado', viewValue: 'Casado(a)' },
      { value: 'separado_divorciado', viewValue: 'Separado(a) / Divorciado(a)' },
      { value: 'viuvo', viewValue: 'ViÃºvo(a)' },
      { value: 'viuvo_companheiro', viewValue: 'Vivo com companheiro(a)' }
    ];

    this.degree = [
      { value: '0', viewValue: 'Ensino fundamental incompleto' },
      { value: '1', viewValue: 'Ensino fundamental completo' },
      { value: '2', viewValue: 'Ensino mÃ©dio incompleto' },
      { value: '3', viewValue: 'Ensino mÃ©dio completo' },
      { value: '4', viewValue: 'Ensino superior incompleto' },
      { value: '5', viewValue: 'Ensino superior completo' },
      { value: '6', viewValue: 'EspecializaÃ§Ã£o' },
      { value: '7', viewValue: 'Mestrado' },
      { value: '8', viewValue: 'Doutorado' },
      { value: '9', viewValue: 'PÃ³s-doutorado' },
      { value: '10', viewValue: 'Ensino tÃ©cnico-profissionalizante incompleto' },
      { value: '11', viewValue: 'Ensino tÃ©cnico-profissionalizante completo' }
    ];

    // Monitorar mudanÃ§a no nome Civil
    this.userForm.get('hasSocialName')?.valueChanges.subscribe(value => {
      this.mostrarcivilName = value;
      const civilName = this.userForm.get('civilName')?.value;
      if (value) {
        this.userForm.get('civilName')?.setValue(civilName);
      } else {
        this.userForm.get('civilName')?.setValue('');
      }
    });

    this.userForm.get('username')?.disable();

    this.userForm.get('censoNaoInformar')?.valueChanges.subscribe((checked) => {
      this.censoCheckboxes(checked);
    });

    this.userForm.get('censoDeficienciaMultipla')?.valueChanges.subscribe((checked) => {
      const selectedCount = Object.keys(this.userForm.controls).filter((key) =>
        key.startsWith('censo') &&
        key !== 'censoNaoInformar' &&
        key !== 'censoDeficienciaMultipla' &&
        key !== 'censoAltasHabilidadesTipo' &&
        key !== 'censoTeaDescricao' &&
        key !== 'censoOutrasDesc' &&
        key !== 'censoDeficienciaFisicaDescricao' &&
        this.userForm.get(key)?.value
      ).length;

      if (selectedCount >= 2) {
        this.userForm.get('censoDeficienciaMultipla')?.setValue(true, { emitEvent: false });
      } else {
        this.userForm.get('censoDeficienciaMultipla')?.setValue(false, { emitEvent: false });
      }
    });

    // Monitora mudanÃ§as nos checkboxes do censo para ativar o checkbox "DeficiÃªncia MÃºltipla"
    Object.keys(this.userForm.controls).forEach((key) => {
      if (
        key.startsWith('censo') &&
        key !== 'censoNaoInformar' &&
        key !== 'censoDeficienciaMultipla' &&
        key !== 'censoAltasHabilidadesTipo' &&
        key !== 'censoTeaDescricao'  &&
        key !== 'censoOutrasDesc' &&
        key !== 'censoDeficienciaFisicaDescricao'
      ) {
        this.userForm.get(key)?.valueChanges.subscribe(() => {
          this.checkDeficienciaMultipla();
        });
      }
    });

    this.userForm.get('censoDeficienciaFisica')?.valueChanges.subscribe((checked) => {
      if (!checked) {
        this.userForm.get('censoDeficienciaFisicaDescricao')?.reset();
      }
    });

    this.userForm.get('censoAltasHabilidades')?.valueChanges.subscribe((checked) => {
      if (!checked) {
        this.userForm.get('censoAltasHabilidadesTipo')?.reset();
      }
    });

    this.userForm.get('censoTea')?.valueChanges.subscribe((checked) => {
      if (!checked) {
        this.userForm.get('censoTeaDescricao')?.reset();
      }
    });

    this.userForm.get('censoOutras')?.valueChanges.subscribe((checked) => {
      if (!checked) {
        this.userForm.get('censoOutrasDesc')?.reset();
      }
    });

    this.userForm.get('censoNaoInformar')?.valueChanges.subscribe((checked) => {
      if (checked) {
        this.userForm.get('censoDescPrioridade1')?.reset();
        this.userForm.get('censoDescPrioridade2')?.reset();
        this.userForm.get('censoDescPrioridade3')?.reset();
        this.userForm.get('censoDescPrioridade4')?.reset();
      }
    });

    // Monitora mudanÃ§a no campo whereLive para atualizar a funÃ§Ã£o de validaÃ§Ã£o
    this.userForm.get('whereLive')?.valueChanges.subscribe(() => {
      this.updateValidation();
    });
    // Monitora mudanÃ§a no campo whereLive para atualizar a funÃ§Ã£o de validaÃ§Ã£o
    this.userForm.get('nationality')?.valueChanges.subscribe(() => {
      this.updateValidation();
    });

    this.userService.getState().subscribe({
      next: (resp) => {
        this.statesApi = resp;
      },
      error: (err) =>{
        console.error('Erro ao buscar estados', err);
      }
    });
    this.userService.getState().subscribe(states => this.statesApi = states);

    //Monitora a sigla de estado selecionada no campo estado de nascimento
    this.userForm.get('stateBirth')?.valueChanges.subscribe(stateId => {
      if (stateId) {
        this.userService.getCitiesByState(stateId).subscribe(cities => this.cityBirthApi = cities);
      } else {
        this.cityBirthApi = [];
      }
    });
    //Monitora a sigla de estado selecionada no campo estado do endereÃ§o
    this.userForm.get('state')?.valueChanges.subscribe(stateId => {
      if (stateId) {
        this.userService.getCitiesByState(stateId).subscribe(cities => this.cityApi = cities);
      } else {
        this.cityApi = [];
      }
    });
    //Monitora a sigla de estado selecionada no campo estado em que realizou graduaÃ§Ã£o
    this.userForm.get('graduationCourseState')?.valueChanges.subscribe(stateId => {
      if (stateId) {
        this.userService.getCitiesByState(stateId).subscribe(cities => this.cityGraduationApi = cities);
      } else {
        this.cityGraduationApi = [];
      }
    });
  }

  ngOnInit(): void {
    this.userService.getUser().subscribe({
      next: (resp) => {
        this.user = resp;
        this.isLoading = false;
        if (this.user) {
          const stateBirthId = +this.user.stateBirth;
          const cityBirthId = +this.user.cityBirth;
          const rgStateIssuerId =  +this.user.rgStateIssuer;
          const stateId =  +this.user.state;
          const cityId = +this.user.city;
          const graduationCourseStateId =  +this.user.graduationCourseState;
          const graduationCourseCityId = +this.user.graduationCourseCity;
          //passando para boleano para desmarcar/marcar o checkbox
          const hasSocialName = +this.user.hasSocialName;
          const censoAltasHabilidadesCheck = this.user.censoAltasHabilidades;
          const censoCegueiraCheck = this.user.censoCegueira;
          const censoTeaCheck = this.user.censoTea;
          const censoDeficienciaAuditivaCheck = this.user.censoDeficienciaAuditiva;
          const censoDeficienciaFisicaCheck = this.user.censoDeficienciaFisica;
          const censoDeficienciaIntelectualCheck = this.user.censoDeficienciaIntelectual;
          const censoNaoInformarCheck = this.user.censoNaoInformar;
          const censoOutrasCheck = this.user.censoOutras;
          const censoSurdezCheck = this.user.censoSurdez;
          const censoSurdocegueiraCheck = this.user.censoSurdocegueira;
          const censoVisaoSubnormalCheck = this.user.censoVisaoSubnormal;

          this.userForm.patchValue({
            name: this.user.name,
            civilName: this.user.civilName,
            email: this.user.email,
            username: this.user.username,
            phone: this.user.phone,
            cellphone: this.user.cellphone,
            email2: this.user.email2,
            born: this.user.born,
            nationality: this.user.nationality,
            stateBirth: stateBirthId,
            cityBirth: cityBirthId,
            stateBirth2: this.user.stateBirth2,
            cityBirth2: this.user.cityBirth2,
            maritalStatus: this.user.maritalStatus,
            gender: this.user.gender,
            gender2: this.user.gender2,
            passaport: this.user.passaport,
            rg: this.user.rg,
            idDocument: this.user.idDocument,
            rneDocument: this.user.rneDocument,
            rgOrganIssuer: this.user.rgOrganIssuer,
            rgStateIssuer: rgStateIssuerId,
            rgDateIssuer: this.user.rgDateIssuer,
            voterRegistration: this.user.voterRegistration,
            voterDate: this.user.voterDate,
            voterZone: this.user.voterZone,
            voterSection: this.user.voterSection,
            militaryDocument: this.user.militaryDocument,
            postalCode: this.user.postalCode,
            address: this.user.address,
            addressNumber: this.user.addressNumber,
            addressComplement: this.user.addressComplement,
            district: this.user.district,
            country: this.user.country,
            state: stateId,
            city: cityId,
            state2: this.user.state2,
            city2: this.user.city2,
            whereLive: this.user.whereLive,
            profession: this.user.profession,
            workplace: this.user.workplace,
            degree: this.user.degree,
            graduationCourse: this.user.graduationCourse,
            graduationCourseInstitution: this.user.graduationCourseInstitution,
            graduationCourseState: graduationCourseStateId,
            graduationCourseCity: graduationCourseCityId,
            graduationCourseDate: this.user.graduationCourseDate,
            censoAltasHabilidades: censoAltasHabilidadesCheck,
            censoAltasHabilidadesTipo: this.user.censoAltasHabilidadesTipo,
            censoCegueira: censoCegueiraCheck,
            censoDeficienciaAuditiva: censoDeficienciaAuditivaCheck,
            censoDeficienciaFisica: censoDeficienciaFisicaCheck,
            censoDeficienciaFisicaDescricao: this.user.censoDeficienciaFisicaDescricao,
            censoDeficienciaIntelectual: censoDeficienciaIntelectualCheck,
            censoDeficienciaMultipla: this.user.censoDeficienciaMultipla,
            censoDescPrioridade1: this.user.censoDescPrioridade1,
            censoDescPrioridade2: this.user.censoDescPrioridade2,
            censoDescPrioridade3: this.user.censoDescPrioridade3,
            censoDescPrioridade4: this.user.censoDescPrioridade4,
            censoNaoInformar: censoNaoInformarCheck,
            censoOutras: censoOutrasCheck,
            censoOutrasDesc: this.user.censoOutrasDesc,
            censoSurdez: censoSurdezCheck,
            censoSurdocegueira: censoSurdocegueiraCheck,
            censoTea: censoTeaCheck,
            censoTeaDescricao: this.user.censoTeaDescricao,
            censoVisaoSubnormal: censoVisaoSubnormalCheck,
            acessibility: this.user.acessibility
          });
          this.userForm.get('hasSocialName')?.setValue(hasSocialName);
          this.userForm.get('censoAltasHabilidades')?.setValue(censoAltasHabilidadesCheck);
          this.userForm.get('censoCegueira')?.setValue(censoCegueiraCheck);
          this.userForm.get('censoDeficienciaAuditiva')?.setValue(censoDeficienciaAuditivaCheck);
          this.userForm.get('censoDeficienciaFisica')?.setValue(censoDeficienciaFisicaCheck);
          this.userForm.get('censoDeficienciaIntelectual')?.setValue(censoDeficienciaIntelectualCheck);
          this.userForm.get('censoNaoInformar')?.setValue(censoNaoInformarCheck);
          this.userForm.get('censoOutras')?.setValue(censoOutrasCheck);
          this.userForm.get('censoSurdez')?.setValue(censoSurdezCheck);
          this.userForm.get('censoSurdocegueira')?.setValue(censoSurdocegueiraCheck);
          this.userForm.get('censoTea')?.setValue(censoTeaCheck);
        }
      },
      error: (err) => {
        console.error('Erro ao buscar usuÃ¡rio', err);
        this.isLoading = false;
      }
    });

  }

  private censoCheckboxes(disable: boolean) {
    Object.keys(this.userForm.controls).forEach((key) => {
      if (key.startsWith('censo') && key !== 'censoNaoInformar') {
        if (disable) {
          this.userForm.get(key)?.disable();
          this.userForm.get(key)?.setValue(false, { emitEvent: false });
        } else {
          this.userForm.get(key)?.enable();
        }
      }
    });
  }
  //Check no campo DeficiÃªncia Multipla caso tenha mais de uma deficiÃªncia selecionada
  private checkDeficienciaMultipla() {
    const selectedCount = Object.keys(this.userForm.controls).filter((key) =>
      key.startsWith('censo') &&
      key !== 'censoNaoInformar' &&
      key !== 'censoDeficienciaMultipla' &&
      key !== 'censoAltasHabilidadesTipo' &&
      key !== 'censoTeaDescricao' &&
      key !== 'censoOutrasDesc' &&
      key !== 'censoDeficienciaFisicaDescricao' &&
      this.userForm.get(key)?.value
    ).length;

    this.userForm.get('censoDeficienciaMultipla')?.setValue(selectedCount >= 2, { emitEvent: false });
  }

  //Atualiza validaÃ§Ã£o de acordo com escolhas do usuÃ¡rio no formulÃ¡rio
  updateValidation() {
    const whereLive = this.userForm.get('whereLive')?.value;
    const nationality = this.userForm.get('nationality')?.value;

    if (whereLive === 'in-brazil') {
      this.userForm.get('state')?.setValidators(Validators.required);
      this.userForm.get('city')?.setValidators(Validators.required);
      this.userForm.get('state2')?.clearValidators();
      this.userForm.get('city2')?.clearValidators();
    } else {
      this.userForm.get('state2')?.setValidators(Validators.required);
      this.userForm.get('city2')?.setValidators(Validators.required);
      this.userForm.get('state')?.clearValidators();
      this.userForm.get('city')?.clearValidators();
    }

    if (nationality === 'brasileira') {
      this.userForm.get('rg')?.setValidators(Validators.required);
      this.userForm.get('rgOrganIssuer')?.setValidators(Validators.required);
      this.userForm.get('rgStateIssuer')?.setValidators(Validators.required);
      this.userForm.get('rgDateIssuer')?.setValidators(Validators.required);
      this.userForm.get('stateBirth')?.setValidators(Validators.required);
      this.userForm.get('cityBirth')?.setValidators(Validators.required);
      this.userForm.get('voterRegistration')?.setValidators(Validators.required);
      this.userForm.get('voterDate')?.setValidators(Validators.required);
      this.userForm.get('voterSection')?.setValidators(Validators.required);
      this.userForm.get('voterZone')?.setValidators(Validators.required);
      this.userForm.get('stateBirth2')?.clearValidators();
      this.userForm.get('cityBirth2')?.clearValidators();
      this.userForm.get('passaport')?.clearValidators();
    } else {
      this.userForm.get('stateBirth2')?.setValidators(Validators.required);
      this.userForm.get('cityBirth2')?.setValidators(Validators.required);
      this.userForm.get('passaport')?.setValidators(Validators.required);
      this.userForm.get('stateBirth')?.clearValidators();
      this.userForm.get('cityBirth')?.clearValidators();
      this.userForm.get('voterRegistration')?.clearValidators();
      this.userForm.get('voterDate')?.clearValidators();
      this.userForm.get('voterSection')?.clearValidators();
      this.userForm.get('voterZone')?.clearValidators();
      this.userForm.get('rg')?.clearValidators();
      this.userForm.get('rgOrganIssuer')?.clearValidators();
      this.userForm.get('rgStateIssuer')?.clearValidators();
      this.userForm.get('rgDateIssuer')?.clearValidators();
    }

    // Atualiza o estado dos campos para refletir as mudanÃ§as de validaÃ§Ã£o
    this.userForm.get('state')?.updateValueAndValidity();
    this.userForm.get('city')?.updateValueAndValidity();
    this.userForm.get('state2')?.updateValueAndValidity();
    this.userForm.get('city2')?.updateValueAndValidity();
    this.userForm.get('stateBirth')?.updateValueAndValidity();
    this.userForm.get('cityBirth')?.updateValueAndValidity();
    this.userForm.get('stateBirth2')?.updateValueAndValidity();
    this.userForm.get('cityBirth2')?.updateValueAndValidity();
    this.userForm.get('passaport')?.updateValueAndValidity();
    this.userForm.get('voterRegistration')?.updateValueAndValidity();
    this.userForm.get('voterDate')?.updateValueAndValidity();
    this.userForm.get('voterSection')?.updateValueAndValidity();
    this.userForm.get('voterZone')?.updateValueAndValidity();
    this.userForm.get('rg')?.updateValueAndValidity();
    this.userForm.get('rgStateIssuer')?.updateValueAndValidity();
    this.userForm.get('rgOrganIssuer')?.updateValueAndValidity();
    this.userForm.get('rgDateIssuer')?.updateValueAndValidity();
  }
  /*Valida os campos do forms e mostra os erros*/
  getControl(name: string) {
    return this.userForm.get(name);
  }

  onAttemptSubmit() {
    this.userForm.markAllAsTouched();

    // Se formulÃ¡rio Ã© invÃ¡lido, faz scroll atÃ© o primeiro erro
    if (this.userForm.invalid) {
      this.scrollToFirstInvalidControl();
      return;
    }

    this.onSubmit();
  }
  scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = document.querySelector(
      'form .ng-invalid'
    ) as HTMLElement;

    if (firstInvalidControl) {
      firstInvalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstInvalidControl.focus();
    }
  }

  onSubmit(): void {
    if (this.userForm.valid) {
      const userValues = this.userForm.getRawValue();
      console.log(userValues);
      // FunÃ§Ã£o para atualizar os checkboxs para string
      const updateUserValue = (key: string) => {
        if (typeof userValues[key] === 'boolean') {
          userValues[key] = userValues[key] ? 1 : "";
        } else if (userValues[key] === 1 || userValues[key] === 0) {
          userValues[key] = userValues[key] === 1 ? 1 : "";
        }
      };

      // Lista dos checkboxs a serem verificados e atualizados
      const checkboxString = [
        'hasSocialName',
        'censoAltasHabilidades',
        'censoDeficienciaAuditiva',
        'censoCegueira',
        'censoDeficienciaFisica',
        'censoDeficienciaIntelectual',
        'censoDeficienciaMultipla',
        'censoNaoInformar',
        'censoOutras',
        'censoSurdez',
        'censoSurdocegueira',
        'censoVisaoSubnormal',
        'censoTea',
        'censoAltasHabilidadesTipo',
        'censoDeficienciaFisicaDescricao',
        'censoOutrasDesc',
        'censoTeaDescricao',
        'censoDescPrioridade1',
        'censoDescPrioridade2',
        'censoDescPrioridade3',
        'censoDescPrioridade4'
      ];

      // Atualiza os valores dos checkboxs para strings "0" ou "1"
      checkboxString.forEach(checkboxString => updateUserValue(checkboxString));
      const updatedUser: User = {...this.user!, ...userValues};
      this.userService.updateUser(updatedUser).subscribe({
        next: (resp) => {
          this.user = resp;
          this.toastService.success("UsuÃ¡rio atualizado com sucesso.");
          this.ngOnInit();
        },
        error: (err) => {
          console.error('Erro ao atualizar usuÃ¡rio', err);
          let errorMessage = "Erro ao atualizar o cadastro, tente novamente";
          if (err?.detail) {
            errorMessage = err.detail;
          } else if (err?.fieldErrors) {
            errorMessage = Object.values(err.fieldErrors).join(" | ");
          }

          this.toastService.error(errorMessage);
        }
      });
      this.userForm.markAllAsTouched();
      return;
    }
  }
}
